import React from 'react';
import {
  Alert, Row, Col, Badge, Button,
  Card
} from 'reactstrap';
import { useSelector } from 'react-redux';
import useRichInsights from '../../hooks/useInsights';
import { AnimatedContent, Typewriter } from '.';

export default function AIAnalysis() {
  const insights = useSelector((state) => state.insights);

  // need to call this to seed state
  useRichInsights();
  const { content } = (insights && insights.richInsights) || {};

  if (!content) {
    return (
      <Card className="m-0 p-4">
        <Alert color="warning">
          No AI analysis content available. Please check your data source.
        </Alert>
      </Card>
    );
  }

  return (
    <Card className="m-0 p-4">
      <h3 className="mb-4">AI Analysis</h3>
      <p className="text-muted mb-4">
        Comparative analysis or purchasing patterns across customer
        segments
      </p>
      <Alert color="info">
        <Typewriter text={content.primaryAnalysis.summary} speed={30} />
      </Alert>

      <AnimatedContent delay={1000} type="slideUp">
        <Row>
          <Col md="12">
            <h4>Key Findings</h4>
            <Row>
              {content.primaryAnalysis.keyFindings.map(
                (finding, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Col md="6" key={index} className="mb-3">
                    <AnimatedContent
                      delay={300 * (index + 1)}
                      type="slideUp"
                    >
                      <div className="p-3 bg-light rounded">
                        <Badge
                          color="primary"
                          className="mr-2"
                        >
                          {index + 1}
                        </Badge>
                        {finding}
                      </div>
                    </AnimatedContent>
                  </Col>
                )
              )}
            </Row>
          </Col>
        </Row>
      </AnimatedContent>

      <AnimatedContent delay={1500} type="slideUp">
        <Row>
          <Col md="12">
            <h4>Start a Conversation</h4>
            <Row>
              {content.primaryAnalysis.explorationTopics.map(
                (topic, index) => (
                  <Col md="4" key={index}>
                    <AnimatedContent
                      delay={500 * (index + 1)}
                      type="scale"
                    >
                      <Button
                        color="primary"
                        outline
                        block
                        className="text-left mb-3 p-3"
                        onClick={() => console.log(
                          `Starting conversation about: ${topic.title}`,
                          topic.context
                        )}
                      >
                        <h5 className="mb-2">
                          {topic.title}
                        </h5>
                        <small className="text-muted">
                          {topic.query}
                        </small>
                      </Button>
                    </AnimatedContent>
                  </Col>
                )
              )}
            </Row>
          </Col>
        </Row>
      </AnimatedContent>
    </Card>
  );
}
